import { React } from "react";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import ButtonComponent from "../Button";
import { FormContainerStyle } from "./style";

function FormComponent() {
  return (
    <FormContainerStyle>
      <Form className="form-cadastro border mb-3">
        <legend>Informações Pessoais</legend>
        <Row className="mb-3">
          <Form.Group as={Col} controlId="formGridName">
            <Form.Label>Nome</Form.Label>
            <Form.Control type="text" placeholder="Digite seu nome..." />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridLastName">
            <Form.Label>Sobrenome</Form.Label>
            <Form.Control type="text" placeholder="Digite seu sobrenome..." />
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col} controlId="formGridEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" placeholder="Enter email" />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" placeholder="Password" />
          </Form.Group>
        </Row>
        <legend>Informações de Endereço</legend>
        <Form.Group className="mb-3" controlId="formGridAddress1">
          <Form.Label>Address</Form.Label>
          <Form.Control placeholder="1234 Main St" />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGridAddress2">
          <Form.Label>Address 2</Form.Label>
          <Form.Control placeholder="Apartment, studio, or floor" />
        </Form.Group>
        <Row className="mb-3">
          <Form.Group as={Col} controlId="formGridCity">
            <Form.Label>City</Form.Label>
            <Form.Control />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridState">
            <Form.Label>State</Form.Label>
            <Form.Select defaultValue="Choose...">
              <option>Choose...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
              <option>...</option>
            </Form.Select>
          </Form.Group>
          <Form.Group as={Col} controlId="formGridZip">
            <Form.Label>Zip</Form.Label>
            <Form.Control />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} controlId="formFile" className="mb-3">
            <Form.Label>Default file input example</Form.Label>
            <Form.Control type="file" />
          </Form.Group>
        </Row>
        <Form.Group className="mb-3" id="formGridCheckbox">
          <Form.Check type="checkbox" label="Check me out" />
        </Form.Group>
        <Row>
          <Col className="d-flex justify-content-center justify-content-lg-end gap-2">
            <ButtonComponent size="10rem" bgColor="#585859" textColor="#FFF">
              Cancelar
            </ButtonComponent>
            <ButtonComponent size="10rem" bgColor="#03A688" textColor="#FFF">
              Enviar
            </ButtonComponent>
          </Col>
        </Row>
      </Form>
    </FormContainerStyle>
  );
}

export default FormComponent;
